import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { toast } from "react-toastify";
import { getCensusPayors, censusPayorAction } from "../services/soar";
import Input from "../common/Input";
import Checkbox from "../common/Checkbox";
import FloatingInput from "../common/FloatingInput";

function RevPayors(props) {
  const navigate = useNavigate();
  const [payors, setPayors] = useState([]);
  const [search, setSearch] = useState("");
  const [showExpired, setShowExpired] = useState(false);
  const [codeFilters, setCodeFilters] = useState([]);
  const [typeFilter, setTypeFilter] = useState("");
  const [addPayorOpen, setAddPayorOpen] = useState(false);
  const [payorName, setPayorName] = useState("");
  const [payorData, setPayorData] = useState({});
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    loadCensusPayors();
  }, []);

  const loadCensusPayors = async () => {
    const response = await getCensusPayors();
    setPayors(response.filter((p) => p.active === true));
    toast.success("Payors loaded");
  };

  const addPayor = async () => {
    if (!payorData.payorName || !payorData.payorCode || !payorData.payorType) {
      toast.error("Please enter all required fields.");
      return;
    }
    if (payors.some((p) => p.name === payorName)) {
      toast.error("Payor Name already exists.");
      return;
    }
    const response = await censusPayorAction({
      command: "insert",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      name: payorData.payorName,
      code: payorData.payorCode,
      type: "Census",
      street1: "",
      street2: "",
      city: "",
      state: "",
      zip: "",
      contact: "",
      phone: "",
      mobile: "",
      email: "",
      effective: new Date(),
      expiration: null,
    });
    if (response.id) {
      toast.success("Payor added successfully.");
      setAddPayorOpen(false);
      setPayorName("");
      navigate(`/rev/payor/${response.id}`);
    }
  };

  const addRemoveCodeFilter = (item) => {
    const cf = [...codeFilters];
    const index = cf.indexOf(item);

    if (index === -1) {
      cf.push(item);
    } else {
      cf.splice(index, 1);
    }
    setCodeFilters(cf);
  };

  const getCodeFilterClass = (item) => {
    return codeFilters.includes(item)
      ? "btn btn-sm btn-success m-1"
      : "btn btn-sm btn-info m-1";
  };

  return (
    <>
      <Modal
        show={addPayorOpen}
        onHide={() => {
          setAddPayorOpen(false);
          setPayorName("");
        }}
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Add Payor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingInput
            name="payorName"
            label="Payor Name"
            value={payorData.payorName}
            onChange={(e) =>
              setPayorData({
                ...payorData,
                payorName: e.currentTarget.value.toUpperCase(),
              })
            }
          />
          <FloatingInput
            name="payorCode"
            label="Code"
            value={payorData.payorCode}
            onChange={(e) =>
              setPayorData({
                ...payorData,
                payorCode: e.currentTarget.value.toUpperCase(),
              })
            }
          />
          <FloatingInput
            name="payorType"
            label="Type"
            value={payorData.payorType}
            onChange={(e) =>
              setPayorData({
                ...payorData,
                payorType: e.currentTarget.value.toUpperCase(),
              })
            }
          />
        </Modal.Body>
        <Modal.Footer>
          <div
            className="btn btn-danger"
            onClick={() => {
              setAddPayorOpen(false);
              setPayorName("");
            }}
          >
            Cancel
          </div>
          <div className="btn btn-success" onClick={() => addPayor()}>
            Save
          </div>
        </Modal.Footer>
      </Modal>
      <div className="row mb-3">
        <div className="col-md-6 mb-3">
          <div className="row">
            <div className="col-10">
              <FloatingInput
                type="text"
                name="Search"
                label="Search by Payor Name"
                placeholder="Search"
                onChange={(e) => {
                  setSearch(e.currentTarget.value);
                }}
                value={search}
              />
            </div>
            <div className="col-2 d-flex align-items-center">
              <i
                className="fas fa-times-circle fa-2x text-danger"
                onClick={() => setSearch("")}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center mb-2 mb-md-0">
              <div className="col pt-3 form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="expired"
                  onChange={(e) => setShowExpired(!showExpired)}
                />
                <label className="form-check-label" htmlFor="expired">
                  Show Expired
                </label>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-md-end">
              {(safyInfo.user.modules.includes("Admin") ||
                safyInfo.user.modules.includes("Rev Cycle")) && (
                <div
                  className="btn btn-success"
                  onClick={() => setAddPayorOpen(true)}
                >
                  Add Payor
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="m-2">
        <div className="row">
          <div className="col-md-8 mb-3">
            <div>Filter by Code</div>
            <div className="d-flex flex-wrap">
              {[...new Set(payors.map((p) => p.code))]
                .sort()
                .map((c, index) => (
                  <div
                    key={`${c}-${index}`}
                    className={getCodeFilterClass(c)}
                    onClick={() => addRemoveCodeFilter(c)}
                  >
                    {c || "?"}
                  </div>
                ))}
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <FloatingInput
              type="select"
              name="filterByType"
              label="Filter by Type"
              options={[
                { _id: "Group", name: "Group" },
                { _id: "Federal", name: "Federal" },
              ]}
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.currentTarget.value)}
            />
          </div>
        </div>
      </div>
      <div className="mb-2 ps-2">
        {`${
          payors?.filter(
            (p) =>
              p.name?.toUpperCase().includes(search?.toUpperCase()) &&
              (typeFilter === ""
                ? p
                : p.type.toUpperCase() === typeFilter.toUpperCase()) &&
              (codeFilters.length > 0 ? codeFilters.includes(p.code) : true) &&
              (showExpired === true ? p : p.expiration == null)
          ).length
        } Payors`}
      </div>
      <div className="row fw-bold mb-2">
        <div className="col-5">Payor Name</div>
        <div className="col">Code</div>
        <div className="col">Type</div>
        <div className="col">Effective Date</div>
        {showExpired === true && <div className="col">Expiration Date</div>}
        <div className="col"></div>
      </div>
      {payors
        ?.filter(
          (p) =>
            p.name?.toUpperCase().includes(search?.toUpperCase()) &&
            (typeFilter === ""
              ? p
              : p.type.toUpperCase() === typeFilter.toUpperCase()) &&
            (codeFilters.length > 0 ? codeFilters.includes(p.code) : true) &&
            (showExpired === true ? p : p.expiration == null)
        )
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((payor, index) => (
          <div
            key={`${payor.id}-${index}`}
            className="row rounded border border-dark bg-light m-1"
          >
            <div className="col-5 py-1">{payor.name}</div>
            <div className="col py-1">{payor.code}</div>
            <div className="col py-1">{payor.type}</div>
            <div className="col py-1">
              {moment(payor.effective).format("MM/DD/YYYY")}
            </div>
            {showExpired === true && (
              <div className="col py-1">
                {payor.expiration != null &&
                  payor.expiration !== "" &&
                  moment(payor.expiration).format("MM/DD/YYYY")}
              </div>
            )}
            <div className="col m-1 py-1">
              <Link title="Open Payor" to={`/rev/payor/${payor.id}`}>
                <i
                  className="fas fa-pen text-primary ms-4 float-end"
                  role="button"
                ></i>
              </Link>
            </div>
          </div>
        ))}
    </>
  );
}

export default RevPayors;
